import { CdkMenuModule } from '@angular/cdk/menu';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChip } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { register } from 'swiper/element/bundle';
import { ByIdPipe } from '../by-id.pipe';
import { CodaltImageComponent } from '../components/codalt-image/codalt-image.component';
import { CodaltUploadFileComponent } from '../components/codalt-upload-file/codalt-upload-file.component';
import { SortingIconComponent } from '../components/sorting-icon.component';
import { HeaderComponent } from '../pages/header/header.component';
import { PlanningFilterComponent } from '../pages/planning-filter/planning-filter.component';
import { DateIndicatorComponent } from '../pages/planning-overview/day/date-indicator/date-indicator.component';
import { SettingsMenuComponent } from '../pages/settings-menu/settings-menu.component';
import { AfasEmployeeTypePipe } from '../pipes/afas-employee-type.pipe';
import { AiDynamicCellContentPipe } from '../pipes/ai-dynamic-cell-content.pipe';
import { DateRangePipe } from '../pipes/date-range.pipe';
import { FilterPipe } from '../pipes/filter.pipe';
import { GramsToKgPipe } from '../pipes/grams-to-kg.pipe';
import { HasFeaturePipe } from '../pipes/has-feature.pipe';
import { HasFunctionalityPipe } from '../pipes/has-functionality.pipe';
import { HasRolePipe } from '../pipes/has-role.pipe';
import { HourtypeIconPipe } from '../pipes/hourtype-icon.pipe';
import { HourtypePipe } from '../pipes/hourtype.pipe';
import { IsNumericPipe } from '../pipes/is-numeric.pipe';
import { MaterialDetailsPipe } from '../pipes/material-details.pipe';
import { MaterialPropertyPipe } from '../pipes/material-property.pipe';
import { MinutesPipe } from '../pipes/minutes.pipe';
import { NonMainRawMaterialsPipe } from '../pipes/non-main-raw-materials.pipe';
import { IsOtherDatePipe } from '../pipes/other-date.pipe';
import { ImageModalComponent } from './components/image-modal/image-modal.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { SimpleTinyComponent } from './components/simple-tiny/simple-tiny.component';
import { Nl2brPipe } from './pipes/nl2br.pipe';
import { SafeHtml } from './pipes/safe-html.pipe';
import { UcFirstPipe } from './pipes/uc-first.pipe';

register();

@NgModule({
    declarations: [
        HeaderComponent,
        SettingsMenuComponent,
        PlanningFilterComponent,
        CodaltUploadFileComponent,
        CodaltImageComponent,
        ImageModalComponent,
        SimpleTinyComponent,
        SortingIconComponent,
        SafeHtml,
        FilterPipe,
        HasRolePipe,
        HasFeaturePipe,
        HasFunctionalityPipe,
        PageHeaderComponent,
        MinutesPipe,
        AfasEmployeeTypePipe,
        AiDynamicCellContentPipe,
        ByIdPipe,
        IsNumericPipe,
        DateIndicatorComponent,
        IsOtherDatePipe,
        Nl2brPipe,
        UcFirstPipe,
        DateRangePipe,
        MaterialPropertyPipe,
        NonMainRawMaterialsPipe,
        MaterialDetailsPipe,
    ],
    imports: [
        CommonModule,
        RouterModule,
        CdkMenuModule,
        MatButtonModule,
        MatListModule,
        ReactiveFormsModule,
        AngularSvgIconModule,
        MatDialogModule,
        MatChip,
        NgOptimizedImage,
        MatIconModule,
        MatAutocompleteModule,
        MatTooltipModule,
        MatInput,
        GramsToKgPipe,
        HourtypeIconPipe,
        HourtypePipe,
    ],
    exports: [
        HeaderComponent,
        SettingsMenuComponent,
        PlanningFilterComponent,
        CodaltUploadFileComponent,
        CodaltImageComponent,
        ImageModalComponent,
        SimpleTinyComponent,
        SortingIconComponent,
        SafeHtml,
        Nl2brPipe,
        FilterPipe,
        PageHeaderComponent,
        HasRolePipe,
        HasFeaturePipe,
        HasFunctionalityPipe,
        MinutesPipe,
        AfasEmployeeTypePipe,
        AiDynamicCellContentPipe,
        ByIdPipe,
        IsNumericPipe,
        DateIndicatorComponent,
        IsOtherDatePipe,
        GramsToKgPipe,
        UcFirstPipe,
        DateRangePipe,
        MaterialPropertyPipe,
        NonMainRawMaterialsPipe,
        MaterialDetailsPipe,
        HourtypeIconPipe,
        HourtypePipe,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GenericModule {}
